// @flow
import React from 'react';
import { useField } from 'formik';
import classNames from 'classnames';
import ReactDropdown from 'react-dropdown';
import 'react-dropdown/style.css';
// eslint-disable-next-line
import styles from "./styles.scss";

export type DropdownOption = {
  value: string | number,
  label: string,
};
type Props = {
  label?: string,
  options: Array<DropdownOption>,
  name: string,
  className?: string,
  onValueChange?: (value: string | number) => void,
  id?: string,
  value?: any,
};
export const FormDropdown = ({
  label,
  options,
  className = '',
  placeholder = '',
  id = '',
  value = null,
  onValueChange,
  showPlaceholder = false,
  ...props
}: Props) => {
  const [field, meta, helpers] = useField(props);
  const selectedOption = showPlaceholder
    ? options.find(item => item.value === field.value)
    : options[0];
  if (!showPlaceholder && !value) {
    helpers.setTouched(true);
    helpers.setValue(selectedOption.value);
  }
  const hasError = !!meta.error;
  const error = meta.error;
  const containerClass = classNames('form-dropdown normal-scroll', className, {
    'field-error': hasError,
  });
  const onChange = (option: DropdownOption) => {
    helpers.setTouched(true);
    helpers.setValue(option.value);
    onValueChange && onValueChange(option.value);
    if (props.selected_country) props.selected_country(option.label);
    if (props.onDropDownChange) props.onDropDownChange(option);
  };
  return (
    <div className={containerClass} id={id || props.name}>
      <label htmlFor={id || field.name}>{error || label}</label>
      <ReactDropdown
        placeholder={placeholder}
        id={id || field.name}
        options={options}
        value={selectedOption}
        onChange={onChange}
        className={className}
        arrowClosed={<span className="arrow-closed" />}
        arrowOpen={<span className="arrow-open" />}
        {...props}
      />
    </div>
  );
};
